import { render, staticRenderFns } from "./itemC.vue?vue&type=template&id=270f5848&scoped=true&"
import script from "./itemC.vue?vue&type=script&lang=js&"
export * from "./itemC.vue?vue&type=script&lang=js&"
import style0 from "./itemC.vue?vue&type=style&index=0&id=270f5848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f5848",
  null
  
)

export default component.exports